'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AvailableReaction = require('../AvailableReaction');

var _AvailableReaction2 = _interopRequireDefault(_AvailableReaction);

require('./_add-reaction-popup.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddReactionPopup = function AddReactionPopup(props) {
  return _react2.default.createElement(
    'div',
    { className: 'add-reaction-popup' },
    _react2.default.createElement(
      'ul',
      { className: 'available-reaction-list' },
      props.validReactions.map(function (reaction) {
        var hasReacted = props.currentUserReactions.includes(reaction);
        return _react2.default.createElement(
          'li',
          { key: reaction },
          _react2.default.createElement(_AvailableReaction2.default, {
            hasReacted: hasReacted,
            onClickReaction: props.onClickReaction,
            reactionType: reaction
          })
        );
      })
    )
  );
};

AddReactionPopup.propTypes = {
  currentUserReactions: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
  onClickReaction: _react.PropTypes.func.isRequired,
  validReactions: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired
};

exports.default = AddReactionPopup;